export default {seo:{title:'Paramètre du compte',description:null},title:'Réglages'};